import { render } from "./paymentPopup.vue?vue&type=template&id=07b6cee5&scoped=true"
import script from "./paymentPopup.vue?vue&type=script&lang=js"
export * from "./paymentPopup.vue?vue&type=script&lang=js"

import "../less/paymentPlans.less?vue&type=style&index=0&id=07b6cee5&scoped=true&lang=css&external"
import "./paymentPopup.vue?vue&type=style&index=1&id=07b6cee5&lang=less"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-07b6cee5"]])

export default __exports__